<template>
  <div class="range-selector-wrapper">
    <!--create CustomSelector and use RangeSlider -->
    <div class="options-block-title">{{ $t('update_date') }}</div>
    <div class="filter-wrapper" :class="activeFilter ? 'open-filter' : ''" @click="toggleFilter()">
      <div class="filter-container">
        <div class="filter-option" :class="filterApplied && 'bold-effect'">
          {{ filterApplied ? filterApplied.label : $t('all_dates') }}
        </div>
        <div class="icon-chevron" />
      </div>
    </div>
    <div
      class="filter-options-wrapper"
      :class="activeFilter ? 'lateral-filter-grow' : 'filter-hidden'"
    >
      <div class="filter-range-wrapper">
        <div class="filter-range-container">
          <div class="range-title">{{ $t('manual_range') }}</div>
          <RangeSlider
            :min-date="minD"
            :max-date="maxD"
            type="update"
            @change="changeFunc"
          />
        </div>
      </div>
      <div
        class="filter-theme"
        :class="!filterApplied ? 'selected-value' : ''"
        @click="PBDRangeChange(null)"
      >
        <div v-if="!filterApplied" class="icon-check" />
        <div class="filter-theme-option">{{ $t('all_dates') }}</div>
      </div>
      <div
        v-for="filter in datesFilterOptions"
        :key="filter.label"
        class="filter-theme"
        :class="filterApplied && filterApplied.label === filter.label ? 'selected-value' : ''"
        @click="PBDRangeChange(filter)"
      >
        <div :class="filterApplied && filterApplied.label === filter.label ? 'icon-check' : ''" />
        <div class="filter-theme-option">{{ filter.label }}</div>
      </div>
    </div>
  </div>
</template>
  
<script>
import dayjs from 'dayjs'
import RangeSlider from './RangeSlider.vue'
import { t } from '../../i18n'

var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

export default {
  components: { RangeSlider },
  data() {
    return {
      activeFilter: false,
      minD: dayjs('2023-07-01T00:00:00Z').format('x'),
      maxD: dayjs(dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z').format('x'),
    }
  },
  computed: {
    filterApplied() {
      if (this.$route.query && this.$route.query.update) {
        let update = this.$route.query.update.split(',')
        let labelSting = ''
        let findEl = this.datesFilterOptions.find(
          el => el.range[0] === update[0] && el.range[1] === update[1]
        )
        if (findEl) {
          labelSting = findEl.label
        } else {
          labelSting =
            dayjs(update[0]).format('YYYY/MM/DD') + ' - ' + dayjs(update[1]).format('YYYY/MM/DD')
        }
        return {
          label: labelSting,
          range: [update[0], update[1]],
        }
      }
      return false
    },
    datesFilterOptions() {
      let datesOptionFilter = []
      if (this.minD && this.maxD) {
        let minDate = new Date(parseInt(this.minD))
        let maxDate = new Date(parseInt(this.maxD))
        let minRangeDate = dayjs(maxDate).subtract(1, 'week')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({
            label: t('last_week'),
            range: [
              dayjs(minRangeDate).format('YYYY-MM-DD') + 'T00:00:00Z',
              dayjs(maxDate).format('YYYY-MM-DD') + 'T00:00:00Z',
            ],
          })
        minRangeDate = dayjs(maxDate).subtract(1, 'month')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({
            label: t('last_month'),
            range: [
              dayjs(minRangeDate).format('YYYY-MM-DD') + 'T00:00:00Z',
              dayjs(maxDate).format('YYYY-MM-DD') + 'T00:00:00Z',
            ],
          })
        minRangeDate = dayjs(maxDate).subtract(3, 'month')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({
            label: t('last_3_months'),
            range: [
              dayjs(minRangeDate).format('YYYY-MM-DD') + 'T00:00:00Z',
              dayjs(maxDate).format('YYYY-MM-DD') + 'T00:00:00Z',
            ],
          })
        minRangeDate = dayjs(maxDate).subtract(1, 'year')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({
            label: t('last_year'),
            range: [
              dayjs(minRangeDate).format('YYYY-MM-DD') + 'T00:00:00Z',
              dayjs(maxDate).format('YYYY-MM-DD') + 'T00:00:00Z',
            ],
          })
      }
      return datesOptionFilter
    },
  },
  methods: {
    toggleFilter() {
      this.activeFilter = !this.activeFilter
    },
    changeFunc(minVal, maxVal) {
      let currentQuery = {
        type: this.$route.query.type,
      }
      currentQuery.update =
        dayjs(minVal).format('YYYY-MM-DD') +
        'T00:00:00Z,' +
        dayjs(maxVal).format('YYYY-MM-DD') +
        'T00:00:00Z'
      this.$router.push({
        name: this.$route.name,
        query: currentQuery,
      })
    },
    PBDRangeChange(fil) {
      let currentQuery = {
        type: this.$route.query.type,
      }
      if (fil) currentQuery.update = fil.range[0] + ',' + fil.range[1]

      //GRJ2EE-9006_select_estadisticas
      this.activeFilter = false
      
      this.$router.push({
        name: this.$route.name,
        query: currentQuery,
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.range-selector-wrapper
  position: relative

  .options-block-title
    m-font-size(14, 20)
    color: $grey
    margin-bottom: vw(8px)

  .filter-options-wrapper
    background-color: #fff
    border: 1px solid $grey-grey
    border-radius: 8px
    padding: vw(10px)
    position: absolute
    top: "calc(100% - %s)" % vw(0px)
    width: 100%

    .filter-range-wrapper
      border-bottom: 1px solid $bcn-grey
      margin-bottom: vw(10px)
      margin-left: vw(-4px)
      margin-right: vw(-4px)
      padding-bottom: vw(10px)

      .filter-range-container
        margin-left: vw(10px)
        margin-right: vw(10px)

        .range-title
          m-font-size(14, 20)

    // box-shadow: 0 4px 10px rgba(105, 105, 115, 0.2)
    .filter-theme
      align-items: center
      border-radius: 6px
      display: flex
      padding: vw(6px) vw(8px) vw(6px) vw(32px)

      &:not(:last-child)
        margin-bottom: vw(5px)

      &:hover
        // &:not(.selected-value)
        background-color: $corpotative-color-very-light
        cursor: pointer

      &.selected-value
        background-color: $corpotative-color-very-light
        cursor: default

        .filter-theme-option
          color: $corporate_color
          font-weight: 600

      .icon-check
        m-icon("check", 16, $corporate_color)
        margin-left: vw(-20px)
        margin-right: vw(5px)

    .filter-theme-option
      m-font-size(14, 18)
      margin-top: 0.1em

  .filter-hidden
    display: none

  .lateral-filter-grow
    animation: growDown 0.25s ease-in-out forwards
    transform-origin: top center
    z-index: 3

  .filter-wrapper
    &.open-filter
      position: relative

      &:before
        background-color: $light-grey
        border-radius: 4px
        content: ""
        height: "calc(100% + %s)" % vw(8px)
        left: vw(-4px)
        position: absolute
        top: vw(-4px)
        width: "calc(100% + %s)" % vw(8px)

      .icon-chevron
        transform: rotate(180deg)

    .icon-chevron
      m-icon("chevron-down", 24)
      transform-origin: 50% 55%
      transition: transform 0.25s ease-in-out

  .filter-container
    align-items: center
    background-color: #fff
    border: 1px solid $grey
    border-radius: 4px
    cursor: pointer
    display: flex
    justify-content: space-between
    padding: vw(10px)
    position: relative
    width: 100%

    .filter-option
      m-font-size(16, 26)
      color: $grey
      color: #000

      &.bold-effect
        font-weight: 600

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)
</style>
